<template>
  <div>
    <div class="container py-3">
      <div class="row mt-5">
        <div class="col-lg-5">
          <c-contact />
        </div>
        <div class="col-lg-7">
          <c-contact-form />
        </div>
      </div>
      <div v-if="constants.googleMap" style="height: 400px">
        <iframe :src="constants.googleMap" style="border: 0; width: 100%; height: 95%" allowfullscreen="" loading="lazy"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import cContact from "../components/cContact.vue";
import cContactForm from "../components/cContactForm.vue";
import { mixin } from "../mixins/mixin.js";
export default {
  metaInfo: {
    titleTemplate: "%s | Kontakt",
    meta: [
      {
        name: "description",
        content:
          "Za sva pitanja kontaktirajte nas putem telefona ili emaila ili ispunite formu za kontakt.",
      },
    ],
  },
  mixins: [mixin],
  components: {
    cContact,
    cContactForm,
  },
  data() {
    return {
      constants: this.$constants,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/contact.vue